module.exports = __webpack_public_path__ + "media/images/emblems/Derendingen-blason-878779b73442bd00132ba0587761a0a3.png";